<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["loyalty_programs"] }}
        </p>
      </div>
      <p class="content_title" v-if="cards.length > 0">
        {{ this.$store.getters.TRANSLATIONS["your_loyalty_cards"] }}
      </p>
      <p class="content_title" v-if="cards && cards.length <= 0">
        {{ this.$store.getters.TRANSLATIONS["no_loyalty_programs"] }}
      </p>
      <div v-if="cards && cards.length > 0">
        <div v-for="item in cards" :key="item.id">
          <div class="cards">
            <p class="code">{{ item.code || "" }}</p>
            <p class="cardLabel">{{ item.label || "" }}</p>
            <img :src="cardIcon" class="card" />
          </div>
          <button class="button select" v-on:click="next(item)">SELECT</button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="add()" class="button">
        {{ this.$store.getters.TRANSLATIONS["add_new_program"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%; text-align: center" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
      this.$router.push("/login");
    } else {
      this.loading = true;
      this.$http
        .get(`${process.env.SERVER_URL}/A420598EE15811EA87D00242AC130003`, {
          headers: {
            "x-access-token": this.$storage.get("parkendaToken")
          }
        })
        .then((response) => {
          console.log("Get user loyalty vouchers response:");
          console.log(response);
          if (response.data) {
            this.cards = response.data;
          } else {
            console.log("Can't get loyalty voucherы information");
          }
        })
        .then(() => {
          return this.$http
            .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            })
            .then((response) => {
              console.log("Get current user response:");
              console.log(response);
              if (response.data) {
                this.$store.dispatch("SAVE_USER", response.data);
                this.defaultCardId = response.data.defaultCardId;
              }
            });
        })
        .catch((error) => {
          let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
          this.$modal.show("dialog", {
            text,
            buttons: [
              {
                title: "OK",
                handler: () => {
                  this.$storage.remove("parkendaToken");
                  this.$router.push("/login");
                }
              }
            ]
          });
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  data() {
    return {
      loading: false,
      cards: [],
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      cardIcon: require("@/assets/new_design/card.png"),
      icon: require("@/assets/icon_back.png"),
      next: (item) => {
        console.log("HERE");
        console.log(this.$storage.get("lastParkingTip"));
        if (
          this.$storage.get("lastParkingTip") &&
          this.$storage.get("lastParkingTip") > 0
        ) {
          this.$modal.show("dialog", {
            text: this.$store.getters.TRANSLATIONS["by_using_loyalty"],
            buttons: [
              {
                title: "NO",
                handler: () => {
                  this.$modal.hide("dialog");
                }
              },
              {
                title: "YES",
                handler: () => {
                  this.$modal.hide("dialog");
                  // Remove tip
                  const timeout = setTimeout(() => {
                    this.loading = true;
                  }, 0);
                  this.$http
                    .post(
                      `${process.env.SERVER_URL}/79fe0c5cf33e4de183b2c42510673434`,
                      {
                        paymentStatusId: this.$storage.get(
                          "requestedVehicleInfo"
                        ).id
                      },
                      {
                        headers: {
                          "x-access-token": this.$storage.get("parkendaToken")
                        }
                      }
                    )
                    .then((response) => {
                      console.log("Remove tip response:");
                      console.log(response);
                      this.$store.dispatch("SAVE_LAST_PARKING_TIP", 0);
                      return this.proceed(item);
                    })
                    .catch((error) => {
                      let text =
                        this.$store.getters.TRANSLATIONS["can_not_remove_tip"];
                      if (
                        error.response &&
                        error.response.data &&
                        error.response.data.message
                      ) {
                        text = error.response.data.message;
                      }
                      this.$modal.show("dialog", {
                        text,
                        buttons: [
                          {
                            title: "OK",
                            handler: () => {
                              this.$router.push("/home");
                            }
                          }
                        ]
                      });
                    })
                    .finally(() => {
                      clearTimeout(timeout);
                      this.loading = false;
                    });
                }
              }
            ]
          });
        } else {
          this.proceed(item);
        }
      },
      proceed: (item) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        return this.$http
          .post(
            `${process.env.SERVER_URL}/E730B085B3604A52A1A5D8A3135ABBD9/${this.$store.getters.REQUESTED_VEHICLE_INFO.onDemandId}`,
            {
              code: item.code,
              userId: this.config.systemUserId
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Apply loyalty response:");
            console.log(response);
            if (response && response.status === 200) {
              if (
                this.$storage.get("lastParkingTip") &&
                this.$storage.get("lastParkingTip") > 0
              ) {
                this.$router.push("/appRating?returnTo=parkingReceiptFinal");
              } else {
                this.$router.push("/appRating?returnTo=paymentProcessed");
              }
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["code_not_valid"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/selectPayment");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },

      add: () => {
        this.$router.push("/loyaltyAdd?returnTo=applyLoyalty");
      },
      back: () => {
        this.$router.go(-1);
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.cards {
  position: relative;
}
.cards p {
  position: absolute;
  color: #fbae31;
}
.code {
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.cardLabel {
  top: 65%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-74%, 59%);
}
.select {
  width: 30%;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/ApplyLoyalty.vue